/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "in_dao",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "in_user",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "canVoteOnPoll",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollClosed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "in_data",
                type: "bytes",
            },
        ],
        name: "onPollCreated",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "in_proposalId",
                type: "bytes32",
            },
        ],
        name: "onPollDestroyed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class VoterAllowListACL__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
VoterAllowListACL__factory.bytecode = _bytecode;
VoterAllowListACL__factory.abi = _abi;
//# sourceMappingURL=VoterAllowListACL__factory.js.map